<p class="typo-h5-extralight mb-3 rounded-2xl bg-background-light-grey p-4 text-center text-text-primary">
  {{ 'baa_signup_account_details_already_have_account' | translate }}
  <a
    class="typo-h5-semibold ml-3 text-primary-blue"
    [routerLink]="
      service.isInvitationFlowSignal()
        ? [...ffdNotesRoutePrefix(), routes.baaSignupFlow, routes.baaSignupLogin]
        : [...ffdNotesRoutePrefix(), routes.login]
    "
    [queryParamsHandling]="service.isInvitationFlowSignal() ? 'preserve' : null"
  >
    {{ 'baa_signup_account_details_log_in' | translate }}
  </a>
</p>

<h2 class="font-poppins text-[26px] font-medium leading-[1.2] text-text-primary">
  {{ 'baa_signup_account_details_title' | translate }}
</h2>

<form [formGroup]="form" (ngSubmit)="onSubmit()" class="mt-3 flex flex-col gap-2">
  <lib-input
    formControlName="firstName"
    [label]="'baa_signup_account_details_first_name' | translate"
    [state]="form.controls.firstName.dirty && form.controls.firstName.invalid ? 'error' : 'normal'"
    [hint]="form.controls.firstName.dirty && form.controls.firstName.invalid ? ('registration_first_name_empty_message' | translate) : ''"
    size="large"
    background="white"
    [alternativeDesign]="true"
  ></lib-input>
  <lib-input
    formControlName="lastName"
    [label]="'baa_signup_account_details_last_name' | translate"
    [state]="form.controls.lastName.dirty && form.controls.lastName.invalid ? 'error' : 'normal'"
    [hint]="form.controls.lastName.dirty && form.controls.lastName.invalid ? ('registration_last_name_empty_message' | translate) : ''"
    size="large"
    background="white"
    [alternativeDesign]="true"
  ></lib-input>

  @if (service.isInvitationFlowSignal()) {
    <lib-input
      formControlName="email"
      [label]="'registration_email_label' | translate"
      [state]="form.controls.email.dirty && form.controls.email.invalid ? 'error' : 'normal'"
      [hint]="form.controls.email.dirty && form.controls.email.invalid ? ('registration_email_validation_message' | translate) : ''"
      size="large"
      background="white"
      [alternativeDesign]="true"
    ></lib-input>
  }

  <lib-dropdown
    formControlName="role"
    [placeholder]="'baa_signup_account_details_role' | translate"
    [dropdownLabel]="''"
    [options]="roleOptions"
    size="large"
    background="white"
    [error]="form.controls.role.dirty && form.controls.role.invalid"
    [hint]="form.controls.role.dirty && form.controls.role.invalid ? ('baa_signup_account_details_role_error' | translate) : ''"
    [alternativeDesign]="true"
  ></lib-dropdown>

  <lib-input
    formControlName="password"
    [label]="'baa_signup_account_details_password' | translate"
    [state]="form.controls.password.dirty && form.controls.password.invalid ? 'error' : 'normal'"
    [type]="isPasswordVisible() ? 'text' : 'password'"
    size="large"
    background="white"
    [alternativeDesign]="true"
  >
    <svg-icon
      rightIcon
      size="md"
      [key]="isPasswordVisible() ? 'px-24-password-false' : 'px-24-password-true'"
      class="text-text-tertiary hover:cursor-pointer"
      (click)="togglePasswordVisibility()"
    ></svg-icon>
  </lib-input>

  <div class="mb-10 ml-4 flex flex-col gap-2">
    <lib-validation-indicator
      [state]="onCheckIndicatorState('minlength')"
      [text]="'baa_signup_password_rules_length' | translate"
      [fontStyle]="'text-[12px] font-normal text-text-tertiary leading-[14px] '"
    />
    <lib-validation-indicator
      [state]="onCheckIndicatorState('lowercase')"
      [text]="'baa_signup_password_rules_lowercase' | translate"
      [fontStyle]="'text-[12px] font-normal text-text-tertiary leading-[14px] '"
    />
    <lib-validation-indicator
      [state]="onCheckIndicatorState('uppercase')"
      [text]="'baa_signup_password_rules_uppercase' | translate"
      [fontStyle]="'text-[12px] font-normal text-text-tertiary leading-[14px] '"
    />
    <lib-validation-indicator
      [state]="onCheckIndicatorState('digit')"
      [text]="'baa_signup_password_rules_digits' | translate"
      [fontStyle]="'text-[12px] font-normal text-text-tertiary leading-[14px] '"
    />
  </div>

  <button type="submit" class="btn-primary mt-2 w-full justify-center" [disabled]="service.isRegistrationLoadingSignal()">
    {{ 'baa_signup_account_details_cta' | translate }}
  </button>
</form>

<p class="typo-h7-extralight mt-4 text-center text-text-tertiary">
  {{ 'baa_signup_account_details_tos_prefix' | translate }}
  <a
    class="typo-h7-semibold text-primary-blue underline"
    target="_blank"
    rel="noopener noreferrer"
    href="https://www.ffd.ai/terms-and-conditions"
    >{{ 'baa_signup_account_details_tos_link' | translate }}</a
  >
  {{ 'baa_signup_account_details_tos_conjunction' | translate }}
  <a
    class="typo-h7-semibold text-primary-blue underline"
    target="_blank"
    rel="noopener noreferrer"
    href="https://www.ffd.ai/privacy-policy"
  >
    {{ 'baa_signup_account_details_privacy_link' | translate }}
  </a>
</p>
